"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HolderNameStyled = exports.CardTypeStyled = exports.CardStyled = exports.CardNumberStyled = exports.CardInfoWrapStyled = exports.CardInfoStyled = exports.CardExpirationStyled = exports.CardExpirationLabel = exports.CardExpirationDateStyled = exports.CardEditStyled = exports.CardDetailsStyled = exports.CardDetailsNameWrapStyled = exports.CardDetailsNameStyled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _variables = require("../../styles/variables");
var _BreakPoints = require("../../styles/BreakPoints");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var CardStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-card'
  };
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n"])));
exports.CardStyled = CardStyled;
var CardTypeStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-card__type'
  };
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 26px;\n\n  svg {\n    height: auto;\n  }\n"])));
exports.CardTypeStyled = CardTypeStyled;
var CardNumberStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-card__number'
  };
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n"])), _variables.FontColor);
exports.CardNumberStyled = CardNumberStyled;
var HolderNameStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-holder__name'
  };
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 300;\n"])), _variables.FontColor);
exports.HolderNameStyled = HolderNameStyled;
var CardExpirationStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-data__wrapper'
  };
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 12px;\n\n  display: flex;\n"])), _variables.FontColor);
exports.CardExpirationStyled = CardExpirationStyled;
var CardExpirationLabel = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-data__label'
  };
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 300;\n  margin-bottom: 4px;\n  margin-inline-end: 4px;\n"])), _variables.FontColor);
exports.CardExpirationLabel = CardExpirationLabel;
var CardExpirationDateStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-data__value'
  };
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 300;\n\n  max-width: 100px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])), _variables.FontColor);
exports.CardExpirationDateStyled = CardExpirationDateStyled;
var CardEditStyled = _styledComponents.default.button.attrs(function () {
  return {
    className: 'msd__payment-method__button'
  };
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n\n  padding: 11px 25px;\n  background-color: ", ";\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 600;\n  border-radius: 21px;\n  border: 0;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), _variables.White, _variables.FontColor);
exports.CardEditStyled = CardEditStyled;
var CardInfoStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-method__information'
  };
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n\n  ", "\n"])), _BreakPoints.mediaFrom.medium(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    margin-bottom: 0;\n  "]))));
exports.CardInfoStyled = CardInfoStyled;
var CardDetailsStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-method__details'
  };
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  margin-inline: 20px auto;\n"])));
exports.CardDetailsStyled = CardDetailsStyled;
var CardDetailsNameStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-method__name'
  };
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-inline-end: 4px;\n"])), _variables.FontColor);
exports.CardDetailsNameStyled = CardDetailsNameStyled;
var CardDetailsNameWrapStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-method__nameWrapper'
  };
})(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  margin-bottom: 4px;\n"])));
exports.CardDetailsNameWrapStyled = CardDetailsNameWrapStyled;
var CardInfoWrapStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__payment-method__wrapper'
  };
})(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n\n  ", ";\n"])), _BreakPoints.mediaFrom.medium(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n    flex-direction: row;\n    align-items: center;\n  "]))));
exports.CardInfoWrapStyled = CardInfoWrapStyled;